function tapfaceEmitter(app) {
  return (args, cb) => {
    app.on('tapface', cb);
  };
}

module.exports = {
  tapfaceEmitter
};


// WEBPACK FOOTER //
// ./src/dialog/emitter/tapface.js